'use strict';

import { get, debounce, set, cloneDeep, isEqual, uniqueId } from 'lodash';

var React = require('react');
var ComponentFactory = require('../../infrastructure/ComponentFactory');

var ComponentActionsCreator = require('../../actions/ComponentActionsCreator');

var PropertyMetadata = require('../../models/PropertyMetadata');
var ComponentInstance = require('../../models/ComponentInstance');

/** @module CheckboxInput
 * @requires lodash
 * @requires react
 * @requires ComponentFactory
 * @requires ComponentActionsCreator
 * @requires PropertyMetadata
 * @requires ComponentInstance
 */
var CheckboxInput = ComponentFactory.Create({
	displayName: "CheckboxInput",
	propTypes: {
		property: React.PropTypes.instanceOf(PropertyMetadata).isRequired,
		component: React.PropTypes.instanceOf(ComponentInstance).isRequired
	},

	/**
	 * @method componentDidMount
	 */
	componentDidMount: function(props) {
		this._debouncedSave = debounce(this._save, 100, this);
		this.componentDidUpdate();
	},

	/**
	 * @method componentDidUpdate
	 */
	componentDidUpdate: function(prevProps, prevState) {
		var name = this.props.property.name,
			path = ['component', 'context', name];

		var isStateChanged = !this._equal(this.state, prevState, 'value');
		var isPropertyChanged = !this._equal(this.props, prevProps, path);
		var isSynced = this._equal(this.state, this.props, 'value', path);
		if (isSynced) return;

		if (isPropertyChanged) {
			this.setState({ value: !!get(this.props, path) });
		} else if(isStateChanged) {
			this._debouncedSave();
		}
	},

	/**
	 * @method _save
	 */
	_save: function() {
		var component = cloneDeep(this.props.component);
		set(component, ['context', this.props.property.name], this.state.value);

		ComponentActionsCreator.updateComponentInstanceContext(component);
	},

	/**
	 * @method _equal
	 */
	_equal: function(first, second, firstpath, secondpath) {
		secondpath = secondpath || firstpath;
		return isEqual(get(first, firstpath), get(second, secondpath));
	},

	/**
	 * @method _onChange
	 */
	_onChange: function(e) {
		this.setState({ value: e.target.checked });
	},

	/**
	 * @method render
	 */
	render: function() {
		var id = uniqueId();
		return (<div className="text-input row">
			<div className="columns input-label">
				<label className="left inline">
					<span className="small-heading">{this.props.property.description}</span>
				</label>
			</div>
			<div className="columns input">
				<div className="switch">
					<input
						id = {id}
						className="small-input"
						type='checkbox'
						checked={get(this.state, 'value')}
						onChange={this._onChange} />
					<label htmlFor={id}></label>
				</div>
			</div>
		</div>);
	}
});

module.exports = CheckboxInput;
